import { OrderedMap, Map } from 'immutable';
import HomeworkTemplate from '../Content/model';

import {
  FETCH_HOMEWORK_TEMPLATE_SUCCESS,
} from './actions';

export default function HomeworkTemplateReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_HOMEWORK_TEMPLATE_SUCCESS:
      return addHomeworkTemplateToMap(state, action);
    default:
      return state;
  }
}

function addHomeworkTemplateToMap(state, { payload, sessionId }) {
  let newState = state;
  newState = newState.set(`${sessionId}`,
      new OrderedMap(payload.reduce((pairs, activity) => {
        const template = HomeworkTemplate.create(activity);
        const mapKey = `${template.unitId}-${template.lessonNumber}`;
        pairs.push([mapKey, template]);
        return pairs;
      }, [])));
  return newState;
}



// WEBPACK FOOTER //
// ./data/Homework/Template/reducer.js